<div class="container">
  <header class="page-header-title" i18n>Template details</header>
  <div class="subline" (click)="backToTemplateOverview()">
    <button class="skideo-flat-button white">
      <img src="assets/icons/arrow-left.svg" alt="back" i18n-alt />
    </button>
    <p i18n>Back</p>
  </div>

  @if (templateItem) {
    <div class="content-card-background">
      <div class="header-wrapper">
        <p class="description"><ng-container i18n>Created on: </ng-container>{{ templateItem.template.created | date:'longDate' }}</p>
        <h2>
          {{ templateItem.title
          }}
          @if (templateItem.createPassword !== null) {
            <img [src]="'assets/icons/locked-dark.svg'" alt="locked-template" />
          }
        </h2>
        <nav class="template-menu" [class.on]="isMenuOpen">
          <button
            registerMenuToggle
            class="toggle-menu"
            [class.on]="isMenuOpen"
            (click)="isMenuOpen = !isMenuOpen"
            (clickedOutside)="isMenuOpen = false">
            <i class="fa-regular fa-xmark" [class.no-display]="isMenuOpen === false"></i>
            <i class="fas fa-ellipsis-v" [class.no-display]="isMenuOpen === true"></i>
          </button>
          <ul class="template-menu-options" [class.open]="isMenuOpen">
            @if (templateItem.builderConfigId) {
              <li class="template-menu-option" [class.open]="isMenuOpen">
                <a class="clean-link" [routerLink]="['/templates', TemplateEditMode.EDIT, templateItem.id]">
                  <img src="assets/icons/pencil.svg" alt="" />
                  <span i18n>Edit template</span>
                </a>
              </li>
              <li class="template-menu-option" [class.open]="isMenuOpen" (click)="copyTemplate(templateItem)">
                <img src="assets/icons/copy.svg" alt="" />
                <span i18n>Copy template</span>
              </li>
            }
            <li class="template-menu-option" [class.open]="isMenuOpen" (click)="editTemplateTitle(templateItem)">
              <img src="assets/icons/pencil.svg" alt="" />
              <span i18n>Change title</span>
            </li>
            @if (currentUser && (currentUser.role === RoleType.ADMIN || currentUser.role === RoleType.SUPERADMIN)) {
              <li class="template-menu-option" [class.open]="isMenuOpen" (click)="editLabels()">
                <img src="assets/icons/label.svg" alt="" />
                <span i18n>Edit labels</span>
              </li>
              <li class="template-menu-option" [class.open]="isMenuOpen" (click)="editTags()">
                <img src="assets/icons/tag.svg" alt="" />
                <span i18n>Edit tags</span>
              </li>
            }
            <li class="template-menu-option" [class.open]="isMenuOpen" (click)="deleteContentOfTemplateItem(templateItem.id)">
              <img src="assets/icons/bin.svg" alt="" />
              <span i18n>Delete created content</span>
            </li>
            <li class="template-menu-option" [class.open]="isMenuOpen" (click)="archiveTemplate(templateItem.id, templateItem.archived)">
              <img src="assets/icons/archive.svg" alt="" />
              @if (templateItem.archived === false) {
                <span i18n>Archive template</span>
              } @else {
                <span i18n>Unarchive template</span>
              }
            </li>
          </ul>
        </nav>
      </div>
      <div class="tag-label-wrapper">
        <div class="option-wrapper label-wrapper">
          <p class="description">Labels</p>
          <div class="option">
            @for (label of labels; track label.id; let lastItem = $last) {
              <p>{{ label.name }}{{ !lastItem ? ',' : '' }}</p>
            }
            @if (labels.length === 0) {
              <p>-</p>
            }
          </div>
        </div>
        <div class="option-wrapper">
          <p class="description">Tags</p>
          <div class="option">
            @for (tag of tags; track tag.id; let lastItem = $last) {
              <p>{{ tag.name }}{{ !lastItem ? ',' : '' }}</p>
            }
            @if (tags.length === 0) {
              <p>-</p>
            }
          </div>
        </div>
      </div>
      <div class="template-item-details">
        <div class="template-card-preview-wrapper">
          <img
            class="template-card-preview"
            [class.archived]="templateItem.archived"
            [src]="templateItem.template.thumbnail"
            alt="template-preview" />
        </div>
        <div class="template-action-wrapper">
          <h4 class="url-header" i18n>Unique content URL</h4>
          <p class="url-subheader" i18n>
            This is your unique link to your created template. Use this link to integrate your template on all channels.
          </p>
          <div class="url-field">
            <img class="link-icon" src="assets/icons/link.svg" alt="" />
            <span class="url-text">{{getUrl(templateItem, 'instant')}}</span>
            <button class="skideo-flat-button green img-left" (click)="copyUrl(getUrl(templateItem, 'instant'))">
              <img src="assets/icons/copy.svg" alt="" />
              <span i18n>Copy</span>
            </button>
          </div>
          <div class="template-card-buttons">
            <a [href]="getUrl(templateItem, 'create')" target="_blank" class="skideo-flat-button green img-right launch-creator">
              <span class="button-text" i18n>Launch creator</span>
              <img src="assets/icons/arrow-right.svg" alt="" />
            </a>
            <button class="skideo-flat-button white img-left" (click)="passwordProtect(templateItem)">
              <img src="assets/icons/unlocked.svg" alt="" />
              <span class="button-text" i18n>Password protect</span>
            </button>
          </div>
        </div>
      </div>
      @if (templateItem) {
        <section class="created-items">
          <header
            class="created-items-header"
            [class.has-content]="content.length > 0"
            (click)="toContentWithTemplateItemId(templateItem.id)">
            <h3 class="created-items-header-title" i18n>Recently created content</h3>
            @if (content.length > 0) {
              <img src="assets/icons/arrow-circle-chevron-right.svg" alt="content-items" />
            }
          </header>
          @if (contentLoading === true) {
            <h4 class="loading-content" i18n>Loading content...</h4>
          }
          @if (contentLoading === false && content.length < 1) {
            <h4 class="no-content" i18n>No content found</h4>
          }
          @for (item of content; track item.id) {
            <li class="content-row">
              <a
                class="content-link"
                [attr.aria-disabled]="item.deleted !== null"
                [routerLink]="['/content/' + item.id]"
                [class.disabled]="item.deleted !== null">
                <div class="content-icon-bg" [class.grey-bg]="item.deleted !== null">
                  @switch (item.type) {
                    @case (ImageTypeEnum.Video) {
                      <i class="fas fa-play-circle content-icon" [class.black]="item.deleted !== null"></i>
                    }
                    @case (ImageTypeEnum.Image) {
                      <i class="far fa-image-polaroid content-icon" [class.black]="item.deleted !== null"></i>
                    }
                    @case (ImageTypeEnum.GIF) {
                      @if (item.deleted === null) {
                        <img src="assets/icons/gif.svg" class="content-icon" alt="" />
                      } @else {
                        <img src="assets/icons/gif-black.svg" class="content-icon" alt="" />
                      }
                    }
                  }
                </div>
                <div class="content-details">
                  <div class="content-details-top">
                    <h3 class="content-details-title" [class.deleted]="item.deleted !== null">{{ item.title }}</h3>
                  </div>
                  <div class="content-details-bottom">
                    @if (item.templateItem.template.items.length > 1) {
                      <p [class.deleted]="item.deleted !== null">
                        {{ item.templateItem.template.title }} / {{ item.templateItem.title }} &nbsp; | &nbsp; &nbsp;
                        {{ item.views.totalCount }} Views
                      </p>
                    }
                    @if (item.templateItem.template.items.length === 1) {
                      <p [class.deleted]="item.deleted !== null">
                        {{ item.templateItem.template.title }} &nbsp; | &nbsp; {{ item.views.totalCount }} Views
                      </p>
                    }
                  </div>
                </div>
              </a>
              @if (item.deleted === null) {
                <div class="content-row-menu">
                  <div class="content-options-button" (click)="selectDropdown(item.id)">
                    <i class="fas fa-ellipsis-v"></i>
                  </div>
                  @if (activeDropdown === item.id) {
                    <div class="content-options-dropdown">
                      <button class="dropdown-button delete-button" (click)="deleteContent(item.id)">
                        <i class="far fa-times-circle"></i>
                        <ng-container i18n>Delete item</ng-container>
                      </button>
                      <button class="dropdown-button report-button" (click)="viewReport(item.id)">
                        <i class="far fa-chart-line"></i>
                        <ng-container i18n>View report</ng-container>
                      </button>
                    </div>
                  }
                </div>
              } @else {
                <div class="content-deleted-wrapper">
                  <i class="fas fa-times-circle"></i>
                  <p i18n>Item deleted</p>
                </div>
                <div class="content-row-deleted">
                  <p i18n>Reason: {{ item.deletedReason }}</p>
                </div>
              }
            </li>
          }
        </section>
      }
    </div>
  }
</div>
